import React from 'react';
const TESTIMONIALS = [{
  text: 'Pensé que el problema era yo. Esto me devolvió la calma.',
  author: 'Lucía, mamá primeriza – 32 años'
}, {
  text: 'Mi bebé sigue despertándose, pero ahora sabemos qué hacer.',
  author: 'Marcos, papá – 35 años'
}, {
  text: 'Por primera vez no sentí culpa.',
  author: 'Carla, mamá – 29 años'
}, {
  text: 'Simple, claro y respetuoso.',
  author: 'Sofía, mamá – 38 años'
}];
export function Testimonials() {
  return <section className="py-10 px-4 bg-gray-50" data-id="element-153">
      <div className="max-w-5xl mx-auto" data-id="element-154">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-8" data-id="element-155">
          💬 LO QUE DICEN OTRAS FAMILIAS
        </h2>

        <div className="grid md:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-156">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white p-5 rounded-xl shadow-sm border border-gray-100" data-id="element-157">
              <div className="flex gap-1 text-yellow-400 mb-3 text-sm" data-id="element-158">
                ⭐⭐⭐⭐⭐
              </div>
              <p className="text-gray-900 font-medium italic mb-4 text-lg" data-id="element-159">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3" data-id="element-160">
                <div className="w-9 h-9 bg-blue-100 rounded-full flex items-center justify-center font-bold text-blue-600 text-sm" data-id="element-161">
                  {t.author[0]}
                </div>
                <span className="font-bold text-gray-600 text-sm" data-id="element-162">
                  {t.author}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}